import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["content"]
const _hoisted_3 = ["content"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    itemscope: "",
    itemtype: "http://schema.org/ImageObject",
    class: _normalizeClass(["schema-image-container", { 'role-art': _ctx.role }]),
    style: _normalizeStyle(_ctx.role ? _ctx.calculateRolePortraitStyle(_ctx.role) : undefined)
  }, [
    _createElementVNode("img", {
      class: "image-content",
      itemprop: "contentUrl",
      src: _ctx.src,
      alt: _ctx.alt
    }, null, 8, _hoisted_1),
    _createElementVNode("meta", {
      itemprop: "name",
      content: _ctx.alt
    }, null, 8, _hoisted_2),
    _createElementVNode("meta", {
      itemprop: "description",
      content: _ctx.description || _ctx.alt
    }, null, 8, _hoisted_3)
  ], 6))
}